// React
import { useEffect, useState } from "react"

// Types
import type { SelectOptionType, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

type Coatype = SelectOptionType & {
  group_coa_code: string
}

export function useCoa({ group_coa_code }: { group_coa_code: string }) {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Coatype[]>([])
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/coa/detailcoabygroupcode?group_code=${group_coa_code}`)
    .then((res: SuccessFetch<{
      payload: {
        coa_id: number
        coa_name: string,
        group_coa_code: string,
        coa_code: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: `${item.coa_code} - ${item.coa_name}`,
          value: item.coa_id.toString(),
          group_coa_code: item.group_coa_code
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [ group_coa_code ])

  return { data, isLoading }
}